import dayjs from "dayjs";

export const formattedArticleDate = (date: string) => {
  if (!date) return "";
  const changedDateForSafari = date.replaceAll(/\./gi, "/");
  if (!dayjs(changedDateForSafari).isValid()) return date;
  return dayjs(changedDateForSafari).format("YYYY.MM.DD");
};
